import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Switch, Typography } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import type { BackupVault } from '@/data/vaults/backupVault';
import { AwsKmsTextField } from './awsKmsTextField';
import { AzureKeyVaultKeyUriTextField } from './azureKeyVaultKeyUriTextField';
import { GcpKmsTextField } from './gcpKmsTextField';
import { Accordion, AccordionDetails, AccordionSummary } from '../accordion';
export const VaultAdvanceOptions = t0 => {
  const $ = _c(17);
  const {
    disabled,
    backupVault,
    setBackupVault,
    customKey,
    setCustomKey,
    vaultAccountId,
    defaultAzureTenantId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider sx={{
      margin: "0 -40px"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccordionSummary><Typography variant="h4">Advanced options</Typography></AccordionSummary>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paddingRight: "0"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    t6 = {
      gap: "16px"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== backupVault || $[7] !== customKey || $[8] !== defaultAzureTenantId || $[9] !== disabled || $[10] !== setBackupVault || $[11] !== setCustomKey || $[12] !== vaultAccountId) {
    t7 = <Accordion>{t3}<AccordionDetails sx={t4}><Stack divider={t5} sx={t6}><KmsKeyOption disabled={disabled} backupVault={backupVault} setBackupVault={setBackupVault} customKey={customKey} setCustomKey={setCustomKey} vaultAccountId={vaultAccountId} defaultAzureTenantId={defaultAzureTenantId} /></Stack></AccordionDetails></Accordion>;
    $[6] = backupVault;
    $[7] = customKey;
    $[8] = defaultAzureTenantId;
    $[9] = disabled;
    $[10] = setBackupVault;
    $[11] = setCustomKey;
    $[12] = vaultAccountId;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider sx={{
      margin: "0 -40px"
    }} />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <Stack sx={t1}>{t2}{t7}{t8}</Stack>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
const KmsKeyOption = t0 => {
  const $ = _c(31);
  const {
    disabled,
    backupVault,
    setBackupVault,
    customKey,
    setCustomKey,
    vaultAccountId,
    defaultAzureTenantId
  } = t0;
  const isGcp = backupVault.vaultAttributes.cloudProvider === Provider.Gcp;
  const isAzure = backupVault.vaultAttributes.cloudProvider === Provider.Azure;
  let t1;
  if ($[0] !== backupVault || $[1] !== isAzure || $[2] !== isGcp || $[3] !== setBackupVault) {
    t1 = () => {
      if (isGcp) {
        setBackupVault({
          ...backupVault,
          vaultAttributes: {
            ...backupVault.vaultAttributes,
            gcp: {
              ...backupVault.vaultAttributes.gcp,
              encryptionKey: ""
            }
          }
        });
      } else {
        if (isAzure) {
          setBackupVault({
            ...backupVault,
            vaultAttributes: {
              ...backupVault.vaultAttributes,
              azure: {
                ...backupVault.vaultAttributes.azure,
                encryptionKey: "",
                cmkKeyVaultTenantId: "",
                cmkAppRegistrationId: ""
              }
            }
          });
        } else {
          setBackupVault({
            ...backupVault,
            vaultAttributes: {
              ...backupVault.vaultAttributes,
              aws: {
                ...backupVault.vaultAttributes.aws,
                encryptionKey: ""
              }
            }
          });
        }
      }
    };
    $[0] = backupVault;
    $[1] = isAzure;
    $[2] = isGcp;
    $[3] = setBackupVault;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const clearEncryptionKey = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "24px"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: "12px",
      alignItems: "center"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== clearEncryptionKey || $[9] !== setCustomKey) {
    t5 = event => {
      setCustomKey(event.target.checked);
      if (!event.target.checked) {
        clearEncryptionKey();
      }
    };
    $[8] = clearEncryptionKey;
    $[9] = setCustomKey;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== customKey || $[12] !== disabled || $[13] !== t5) {
    t6 = <Switch size="small" disabled={disabled} checked={customKey} onChange={t5} />;
    $[11] = customKey;
    $[12] = disabled;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = isGcp ? "Use my own Cloud KMS key" : isAzure ? "Use my own Key Vault key" : "Use my own KMS key";
  let t8;
  if ($[15] !== t7) {
    t8 = <Typography>{t7}</Typography>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <Stack direction="row" sx={t4}>{t6}{t8}</Stack>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== backupVault || $[21] !== customKey || $[22] !== defaultAzureTenantId || $[23] !== isAzure || $[24] !== isGcp || $[25] !== setBackupVault || $[26] !== vaultAccountId) {
    t10 = customKey && <Stack sx={{
      width: "400px",
      justifyContent: "flex-end"
    }}>{isGcp ? <GcpKmsTextField backupVault={backupVault} setBackupVault={setBackupVault} /> : isAzure ? <AzureKeyVaultKeyUriTextField backupVault={backupVault} setBackupVault={setBackupVault} vaultAccountId={vaultAccountId} defaultAzureTenantId={defaultAzureTenantId} /> : <AwsKmsTextField backupVault={backupVault} setBackupVault={setBackupVault} />}</Stack>;
    $[20] = backupVault;
    $[21] = customKey;
    $[22] = defaultAzureTenantId;
    $[23] = isAzure;
    $[24] = isGcp;
    $[25] = setBackupVault;
    $[26] = vaultAccountId;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <Stack className="w-full" sx={t2}><Stack direction="row" sx={t3}>{t9}{t10}</Stack></Stack>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};